// A landing em inglês é pré-renderizada em `/en/index.html`, então o servidor
// pode entregá-la tanto em `/en` quanto em `/en/`. Normalizar a barra final aqui
// mantém as duas formas na mesma rota — sem isso, `/en/` não casa com a landing
// e cai na rota protegida (que joga o visitante para o login).

/** Remove a barra final, preservando a raiz ("/"). */
export function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

/** A landing vive em "/" (pt-BR) e "/en" (inglês). */
export function isLandingPath(pathname: string): boolean {
  const path = normalizePath(pathname);
  return path === "/" || path === "/en";
}

/** Idioma que a URL da landing determina (fonte de verdade, para SEO). */
export function landingLang(pathname: string): "en" | "pt-BR" {
  return normalizePath(pathname) === "/en" ? "en" : "pt-BR";
}
